export default class EventReport
{
    year = 0
    month = 0
    
    days = {}
}
